import { RootState } from 'store';
import { IDataResponse } from 'types';

const selectContragentsData = (state: RootState): IDataResponse => state.contragent.data;
export default selectContragentsData;
